import { SurveyR } from "../../pages/surveys/route";
import { MenuList as GCDKMenuList } from "@graffer-inc/console-design-kit";
import { NavLink, useRouteMatch } from "react-router-dom";

export const MenuList = ({
  menuLinkOverrideAction,
}: {
  menuLinkOverrideAction?: (path: string) => void;
}) => {
  const { path } = useRouteMatch();

  return (
    <GCDKMenuList
      items={[
        {
          header: "アンケート管理",
          navItems: [
            {
              title: "アンケート一覧",
              hidden: false,
              anchor: (props) => (
                <NavLink
                  {...props}
                  to={SurveyR.Surveys.link({})}
                  onClick={
                    menuLinkOverrideAction
                      ? (e: React.MouseEvent<HTMLAnchorElement>) => {
                          e.preventDefault();
                          menuLinkOverrideAction(SurveyR.Surveys.link({}));
                        }
                      : undefined
                  }
                />
              ),
              active: path === SurveyR.Surveys.link({}),
            },
          ],
        },
      ]}
    />
  );
};
